import { WindowTitle } from "@saleor/components/WindowTitle";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import StoreDetailsFinanceListComponent from "./views/StoreDetailsFinanceList";
const StoreDetailsFinanceList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <StoreDetailsFinanceListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Store Details",
          description: "store details report section name"
        })}
      />

      <Routes>
        <Route path={""} element={<StoreDetailsFinanceList />} />
      </Routes>
    </>
  );
};

export default Component;
